<div class="flex align-items-center gap-2">
  @if (dataLayerType.icon) {
    <app-svg-icon style="width: 18px" [key]="dataLayerType.icon"></app-svg-icon>
  } @else {
    <i *ngIf="!dataLayerType.icon" class="fa-regular fa-map"></i>
  }
  <span>{{ dataLayerType.name }}</span>
</div>
